import { createSlice, PayloadAction, Slice } from '@reduxjs/toolkit';
import { ProfileState } from './profile.types';
import { RootState } from '../store';
import { Profile } from '@src/services/profile/profileTypes';

const initialState: ProfileState = {
    data: null,
    loading: false,
};

export const profileSlice: Slice<ProfileState> = createSlice({
    name: 'profile',
    initialState,
    reducers: {
        setProfile: (state, action: PayloadAction<Profile>) => {
            state.data = action.payload;
        },
        clearProfile: (state) => {
            state.data = null;
        },
        setLoading: (state, action: PayloadAction<boolean>) => {
            state.loading = action.payload;
        },
    },
});

export const { setProfile, clearProfile, setLoading } = profileSlice.actions;
export const selectProfile = (state: RootState) => state.profile.data;
export default profileSlice.reducer;
